import { render, staticRenderFns } from "./OsCardTitle.vue?vue&type=template&id=7f126719&scoped=true"
import script from "./OsCardTitle.vue?vue&type=script&lang=ts"
export * from "./OsCardTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f126719",
  null
  
)

export default component.exports